<template>
  <div>
    <b-container fluid>
      <b-row class="mb-1">
        <b-col lg="12" md="12" sm="12" class="px-0">
          <div
            v-if="$route.query.profile"
            class="d-flex justify-content-between align-items-center top-div"
          >
            <div class="d-flex align-items-center">
              <router-link button to="/profile">
                <b-icon icon="arrow-left-short"></b-icon>
              </router-link>
              <h5>
                <b>{{ $t(getTranslationKey($route.query.profile)) }}</b>
              </h5>
            </div>
            <button
              class="left"
              @click="() => this.$bvModal.show('bv-add-address')"
            >
              {{ $t("viewAddress.addAddress") }}
            </button>
          </div>
          <h5 v-else class="right">{{ $t("viewAddress.title") }}</h5>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      id="bv-add-address"
      size="lg"
      :hide-footer="true"
      :hide-header="true"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      centered
      header-class="my-class"
      body-class="p-0"
    >
      <template v-if="$options.components['address-add-address-modal']">
        <address-add-address-modal />
      </template>
    </b-modal>
    <b-row v-if="this.deliveryAddress.length !== 0" class="d-flex row-list">
      <b-col
        md="6"
        lg="4"
        sm="12"
        class="body mb-2"
        v-for="(address, index) in deliveryAddress"
        :key="index"
      >
        <b-card-text>
          <div class="d-flex justify-content-between">
            <p :value="address" class="heading-name">
              {{ address.fullName }}
              <large
                v-if="address.isDefault"
                class="default-address-class ml-5"
              >
                {{ $t("viewAddress.default") }}
              </large>
            </p>
            <div class="">
              <span
                v-if="
                  $store.state['address'].deleteAddressLoading != address._id
                "
                class="float-right"
              >
                <img
                  class="edit-icon-style"
                  @click="
                    () => {
                      editAddressClick(address);
                      $bvModal.show(address._id);
                    }
                  "
                  src="img/EditIcon.png"
                  alt=""
                />
                <img
                  @click="() => deleteAddress(address._id)"
                  style="cursor: pointer"
                  src="img/address/Trash.png"
                  alt=""
                />
                <b-modal
                  :id="address._id"
                  size="lg"
                  :hide-footer="true"
                  :hide-header="true"
                  :no-close-on-esc="true"
                  :no-close-on-backdrop="true"
                  centered
                  header-class="my-class"
                  body-class="p-0"
                >
                  <template
                    v-if="$options.components['address-edit-address-modal']"
                  >
                    <address-edit-address-modal
                      ref="editAddressRef"
                      :address="address"
                    />
                  </template>
                </b-modal>
              </span>
              <span
                v-if="
                  $store.state['address'].deleteAddressLoading == address._id
                "
                class="float-right"
              >
                <b-spinner
                  v-for="i in 3"
                  :key="i"
                  class="mr-1"
                  small
                  label="Small Spinner"
                  type="grow"
                ></b-spinner>
              </span>
            </div>
          </div>
          <div class="address-lines">
            <p class="address-line">
              {{ address.houseNumber }}, {{ address.street1 }}
            </p>
            <p class="address-line">
              {{ address.street2 }}, {{ address.city }}
            </p>
            <p class="address-line">{{ address.state }} - {{ address.zip }}</p>
          </div>
        </b-card-text>
      </b-col>
    </b-row>
    <p v-if="this.deliveryAddress.length == 0" class="add-address text-center">
      {{ $t("viewAddress.pleaseAddAddress") }}
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "View_Address_Edit",
  computed: {
    ...mapState({
      deliveryAddress: (state) => state.address.deliveryAddress,
    }),
  },
  data: () => {
    return {
      len: null,
    };
  },
  methods: {
    getTranslationKey(label) {
      const map = {
        "View Address": "accountDetails.viewAddress",
        "Edit Profile": "editProfile",
      };
      return map[label] || label;
    },
    async deleteAddress(e) {
      this.$bvModal
        .msgBoxConfirm("Do you want to delete your address?", {
          title: "Please Confirm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.$store.dispatch("address/deleteAddress", e);
            this.$store.dispatch("checkout/checkoutFinal");
            this.$swal({
              text: this.$t("swal.addressDeleted"),
              type: "success",
              title: this.$t("swal.title"),
              timer: 900,
            });
          }
        });
    },
    editAddressClick(e) {
      this.$emit("editAddress", e);
    },
    addAddress() {
      this.$bvModal.show("bv-add-address");
    },
    async fetchAddressList() {
      await this.$store.dispatch("address/fetchDeliveryAddress");
    },
  },

  async mounted() {
    await this.fetchAddressList();
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap");

:root {
  --primarycolor: #ff7300;
  --card-bg: #fff;
  --card-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  --border-radius: 16px;
  --transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

body,
.container,
.b-container {
  font-family: "Roboto", sans-serif;
  background: #f4f6fb;
}

.top-div {
  background: #fff;
  border-radius: var(--border-radius);
  box-shadow: var(--card-shadow);
  padding: 1.5rem 1rem;
  /* margin-bottom: 2rem; */
}

.left {
  color: var(--primarycolor);
  font-size: 15px;
  font-weight: 500;
  border: 1.5px solid var(--primarycolor);
  border-radius: 6px;
  padding: 10px 28px;
  min-width: 140px;
  background: #fff;
  transition: var(--transition);
  box-shadow: 0 2px 8px rgba(255, 115, 0, 0.07);
  outline: none;
}
.left:hover,
.left:focus {
  background-color: var(--primarycolor);
  color: #fff;
  box-shadow: 0 4px 16px rgba(255, 115, 0, 0.13);
}

.right {
  font-weight: bold;
  font-size: 1.3rem;
  text-align: center;
  margin-bottom: 1.5rem;
  color: #222;
}
.address-lines {
  margin-top: 0.5rem;
}

.address-line {
  margin: 0;
  font-size: 16px;
  line-height: 1.4;
  color: #333;
}

.add-address {
  font-size: 18px;
  font-weight: 600;
  margin-top: 30px;
  font-family: "Roboto", sans-serif;
  color: #888;
}

.row-list {
  gap: 2rem;
  margin-bottom: 2rem;
}

.body {
  background: var(--card-bg);
  border-radius: var(--border-radius);
  box-shadow: var(--card-shadow);
  padding: 1.5rem 1.2rem;
  transition: var(--transition);
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #f0f0f0;
}
.body:hover {
  box-shadow: 0 6px 24px rgba(255, 115, 0, 0.1);
  border-color: var(--primarycolor);
}

.edit-icon-style {
  cursor: pointer;
  scale: 1.1;
  margin-top: 4px;
  transition: transform 0.2s;
}
.edit-icon-style:hover {
  transform: scale(1.1) rotate(-8deg);
}

.heading-name {
  font-weight: 700;
  font-size: 1.1rem;
  color: #222;
  margin-bottom: 0.2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.default-address-class {
  font-size: 13px;
  font-weight: 500;
  color: var(--primarycolor);
  background: #fff3e6;
  border-radius: 8px;
  padding: 2px 10px;
  margin-left: 12px;
}

b-card-text p {
  margin-bottom: 0.3rem;
  color: #444;
  font-size: 1rem;
  word-break: break-word;
}

.float-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

@media (max-width: 1200px) {
  .row-list {
    gap: 1.2rem;
  }
  .body {
    padding: 1.2rem 0.8rem;
  }
}

@media (max-width: 992px) {
  .body {
    min-height: 160px;
  }
}

@media (max-width: 768px) {
  .top-div {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 0.5rem;
    /* margin-bottom: 1.2rem; */
  }
  .left {
    width: 100%;
    padding: 10px;
    margin-bottom: 1rem;
    min-width: unset;
  }
  .right {
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }
  .body {
    padding: 1rem 0.5rem;
    margin: 0 0.5rem;
    min-height: 140px;
  }
  .heading-name {
    font-size: 1rem;
  }
  .edit-icon-style {
    height: 28px;
    width: 24px;
  }
  .default-address-class {
    margin-left: 0 !important;
    margin-top: 4px;
    display: inline-block;
  }
}

@media (max-width: 576px) {
  .row-list {
    gap: 0.5rem;
  }
  .body {
    padding: 0.8rem 0.3rem;
    min-height: 120px;
  }
  .heading-name {
    font-size: 0.95rem;
  }
  .default-address-class {
    font-size: 12px;
    padding: 2px 8px;
  }
  .edit-icon-style {
    height: 22px;
    width: 18px;
  }
  .top-div {
    padding: 0.7rem 0.2rem;
  }
}

.bi-arrow-left-short {
  height: 3rem;
  width: 3rem;
  color: var(--primarycolor);
  padding: 0px;
}

.bi-arrow-left-short:hover {
  color: var(--darkcolor);
}

b-modal {
  margin: 10px;
  border-radius: var(--border-radius);
}

::-webkit-scrollbar {
  width: 8px;
  background: #f4f6fb;
}
::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 8px;
}
</style>
